const secondaryConfig = {
  apiKey: "AIzaSyBcqgS1V5IndTOM0pG3Ur5JEpsEZR49LSY",
  authDomain: "we-kiosk.firebaseapp.com",
  databaseURL: "https://we-kiosk.firebaseio.com",
  projectId: "we-kiosk",
  storageBucket: "cdn2.we-eats.com",
  messagingSenderId: "155395335863",
  appId: "1:155395335863:web:b8ce941a190fb072d24f32",
};

export default secondaryConfig
